import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor,
	HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {

	private headers = new HttpHeaders();

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		if (localStorage.getItem('authToken')) {
			request = request.clone({
				setHeaders: {
					'Accept': '*',
					'Content-Type': 'application/json',
					'Authorization': localStorage.getItem('authToken')
				}
			});
		}
		return next.handle(request);
	}
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/core/interceptors/token.interceptor.ts